import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from '@lassi/util';

@Pipe({
  name: 'defaultDash',
  standalone: true,
})
export class DefaultDashPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any): string {
    if (isNil(value) || value === '') {
      return '-';
    }
    return value;
  }
}

@Pipe({
  name: 'capitalizeFirst',
  standalone: true,
})
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
